import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/Home.vue'
import Product from '../views/product/Product.vue'
import ProductDetail from '../views/product/Detail.vue'
import ProductSearchByImage from '../views/product/ProductSearchByImage.vue'
import ProductSearchByMoreImage from '../views/product/ProductSearchByMoreImage.vue'
import Merchant from '../views/merchant/Merchant.vue'
import MerchantDetail from '../views/merchant/Detail.vue'
import JoinUs from '../views/merchant/JoinUs.vue'
import Cart from '../views/cart/Cart.vue'
import Follow from '../views/user/Follow.vue'
import Purchasing from '../views/user/Purchasing.vue'
import Login from '../Login.vue'

Vue.use(VueRouter)

const routes = [{
	path: '/',
	redirect: '/home'
}, {
	path: '/home',
	name: 'Home',
	component: Home
}, {
	path: '/login',
	name: 'Login',
	component: Login
}, {
	path: '/product',
	name: 'Product',
	component: Product
}, {
	path: '/product-detail',
	name: 'ProductDetail',
	component: ProductDetail
}, {
	path: '/product-search-image',
	name: 'ProductSearchByImage',
	component: ProductSearchByImage
}, {
	path: '/product-search-more-image',
	name: 'ProductSearchByMoreImage',
	component: ProductSearchByMoreImage
}, {
	path: '/merchant',
	name: 'Merchant',
	component: Merchant
}, {
	path: '/merchant-detail',
	name: 'MerchantDetail',
	component: MerchantDetail
}, {
	path: '/join-us',
	name: 'JoinUs',
	component: JoinUs
}, {
	path: '/cart',
	name: 'Cart',
	component: Cart
}, {
	path: '/follow',
	name: 'Follow',
	component: Follow
}, {
	path: '/purchasing',
	name: 'Purchasing',
	component: Purchasing
}]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

// 全局导航守卫，当路由发生改变时，将页面滚动到顶部
router.afterEach(() => {
	window.scrollTo(0, 0);
});

export default router